module.exports = __webpack_public_path__ + "images/category_lp/pc/SP_1_ca054a26b7df77ec155c95c187be26d9.png";